import api from '../services/api.js'

// Диагностика потерянного ответа.
//
// Замер 27 августа 2026 по zoya_token_usage: на PWA от трети до половины
// вызовов /ai/recognize-label — повтор той же картинки, на нативном Android
// 2,5%. Сервер при этом отвечает 200 с телом (это видно в логе nginx), то есть
// ответ уходит с сервера, а до кода приложения не доходит. Кто его теряет,
// с сервера не видно совсем: нужен код ошибки XHR, время до сбоя, состояние
// вкладки и версия service worker — всё это есть только на устройстве.
//
// Отчет уходит после того, как ошибка уже случилась, не повторяется и своё
// собственное падение проглатывает: диагностика не имеет права ломать сценарий.

export function startNetProbe() {
  const startedAt = Date.now()
  // Уход вкладки в фон во время запроса — одна из проверяемых версий,
  // поэтому важен сам факт, а не состояние на момент ошибки.
  let wasHidden = document.visibilityState === 'hidden'
  const onVisibility = () => { if (document.visibilityState === 'hidden') wasHidden = true }
  document.addEventListener('visibilitychange', onVisibility)

  const stop = () => document.removeEventListener('visibilitychange', onVisibility)

  return {
    done: stop,
    lost(endpoint, err, attempt) {
      stop()
      const conn = navigator.connection || {}
      const sw = navigator.serviceWorker?.controller
      api.post('/ai/net-report', {
        endpoint,
        attempt,
        ms: Date.now() - startedAt,
        code: err?.code || null,
        message: String(err?.message || '').slice(0, 120),
        online: navigator.onLine,
        net: conn.effectiveType || null,
        rtt: conn.rtt ?? null,
        hidden: wasHidden,
        sw: sw ? sw.scriptURL.slice(-40) : null,
        standalone: window.matchMedia?.('(display-mode: standalone)').matches || !!navigator.standalone,
        version: typeof __APP_VERSION__ === 'string' ? __APP_VERSION__ : null,
      }).catch(() => {})
    },
  }
}
